import * as CPL from '@teamsparta/cross-platform-logger';

export function initCPL() {
  CPL.initCPLog(
    process.env.NEXT_PUBLIC_FLOUNDER_KEY as string,
    process.env.NEXT_PUBLIC_AMPLITUDE_KEY as string,
    process.env.NEXT_PUBLIC_HACKLE_SDK_KEY as string,
    process.env.NEXT_PUBLIC_BRAZE_API_KEY,
    process.env.NEXT_PUBLIC_BRAZE_SDK_ENDPOINT,
    !JSON.parse(JSON.parse(process.env.IS_PROD as string)),
  );
}
